module.exports = __webpack_public_path__ + "static/media/alpha_3.55acbdaf.png";